// extracted by mini-css-extract-plugin
export default {"root":"LinkButton_root__RnsmD"};